/**
 * cart-page-premium.js
 * Real AJAX cart interactions: quantity change, remove line item, quick-add
 * from the upsell row — all via Shopify's /cart/change.js and /cart/add.js,
 * with live subtotal/total/item-count/shipping-bar updates and no full
 * page reload.
 */
(function () {
  'use strict';

  var root = document.querySelector('.ct-cart');
  if (!root) return;

  function moneyFormat(cents) {
    return 'Rs' + (cents / 100).toFixed(2);
  }

  function updateShippingBar(cart) {
    var bar = document.querySelector('.ct-shipping-bar');
    if (!bar) return;
    var thresholdAttr = bar.dataset.threshold;
    var thresholdCents = thresholdAttr ? parseFloat(thresholdAttr) * 100 : null;
    if (!thresholdCents) return;

    var fill = bar.querySelector('[data-ct-shipping-progress]');
    var remainingEl = bar.querySelector('[data-ct-shipping-remaining]');
    var percent = Math.min(100, (cart.total_price / thresholdCents) * 100);
    if (fill) fill.style.width = percent + '%';

    if (cart.total_price >= thresholdCents) {
      bar.innerHTML =
        '<p class="ct-shipping-bar--success">Congratulations! You\'ve earned free shipping.</p>' +
        '<div class="ct-shipping-bar__track"><div class="ct-shipping-bar__fill" data-ct-shipping-progress style="width:100%;"></div></div>';
    } else if (remainingEl) {
      var remaining = ((thresholdCents - cart.total_price) / 100).toFixed(2);
      remainingEl.textContent = 'Rs' + remaining;
    }
  }

  function updatePageFromCart(cart) {
    var itemCountEls = document.querySelectorAll('[data-ct-item-count]');
    itemCountEls.forEach(function (el) {
      el.textContent = cart.item_count + ' Item' + (cart.item_count !== 1 ? 's' : '');
    });

    var subtotalEl = document.querySelector('[data-ct-subtotal]');
    var totalEl = document.querySelector('[data-ct-total]');
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
    if (totalEl) totalEl.textContent = moneyFormat(cart.total_price);

    updateShippingBar(cart);

    // Update header cart icon badge too, if the premium header package is
    // installed on this theme.
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
  }

  function changeLineItem(key, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-removing');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (quantity === 0 && itemEl) {
          itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
          window.requestAnimationFrame(function () {
            itemEl.style.transition = 'max-height 350ms ease, opacity 350ms ease, padding 350ms ease, margin 350ms ease';
            itemEl.style.maxHeight = '0px';
            itemEl.style.opacity = '0';
            itemEl.style.overflow = 'hidden';
          });
          window.setTimeout(function () { itemEl.remove(); }, 380);
        } else if (itemEl) {
          var lineItem = cart.items.find(function (i) { return i.key === key; });
          if (lineItem) {
            var lineTotalEl = itemEl.querySelector('[data-ct-item-line-total]');
            if (lineTotalEl) lineTotalEl.textContent = moneyFormat(lineItem.final_line_price);
          }
          itemEl.classList.remove('is-removing');
        }
        updatePageFromCart(cart);
        return cart;
      });
  }

  root.querySelectorAll('[data-ct-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var itemEl = btn.closest('[data-ct-item-key]');
      var input = itemEl.querySelector('[data-ct-qty-input]');
      var newQty = parseInt(input.value, 10) + 1;
      input.value = newQty;
      changeLineItem(itemEl.dataset.ctItemKey, newQty, itemEl);
    });
  });

  root.querySelectorAll('[data-ct-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var itemEl = btn.closest('[data-ct-item-key]');
      var input = itemEl.querySelector('[data-ct-qty-input]');
      var newQty = Math.max(0, parseInt(input.value, 10) - 1);
      input.value = newQty;
      changeLineItem(itemEl.dataset.ctItemKey, newQty, itemEl);
    });
  });

  root.querySelectorAll('[data-ct-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var itemEl = input.closest('[data-ct-item-key]');
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLineItem(itemEl.dataset.ctItemKey, newQty, itemEl);
    });
  });

  root.querySelectorAll('[data-ct-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var itemEl = btn.closest('[data-ct-item-key]');
      changeLineItem(itemEl.dataset.ctItemKey, 0, itemEl);
    });
  });

  root.querySelectorAll('[data-ct-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  });

})();
